import { image } from '../../../../utils/data/baseUrl';

export default {
  button: {
    attr: {
      className: 'drawing-result-button',
      timeout: 1000,
    },
    text: 'other.drawing',
    img: image('drawing/button.png'),
  },
  modal: {
    win: {
      close: {
        attr: {
          className: 'winnings-modal__close custom-button_closeModal',
          icon: 'buttons/closeModal',
        },
      },
      title: 'winningsModalContent.win.title',
      text: {
        standard: 'winningsModalContent.win.text.standard',
        bonuses: 'winningsModalContent.win.text.bonuses',
      },
      subtext: 'winningsModalContent.win.subtext',
      listTitle: 'winningsModalContent.win.listTitle',
      buttonEnd: {
        text: 'winningsModalContent.win.buttonEnd.text',
        className: 'winnings-modal__button',
      },
      navigation: ['prev', 'next'],
      carousel: {
        slidesPerView: 'auto',
        centeredSlides: true,
        spaceBetween: 50,
        loop: false,
        navigation: {
          prevEl: '.drawing-result-modal__prize-nav_prev',
          nextEl: '.drawing-result-modal__prize-nav_next',
        },
      },
    },
    lose: {
      title: 'winningsModalContent.lose.title',
      text: {
        standard: 'winningsModalContent.lose.text',
      },
      button: {
        text: 'winningsModalContent.lose.button.text',
        className: 'winnings-modal__button winnings-modal__button_lose',
        modalData: { action: 'close', data: { type: 'current' } },
      },
      listTitle: 'winningsModalContent.lose.listTitle',
    },
  },
};
